import moment from 'moment';

export const getEvent = ({ date, events, event }) => {
  const checkIsDateInDate = event => {
    if (!event) {
      return false;
    }

    const { multiplicator, period, start_date, stop_date } = event;

    if (!start_date) {
      return false;
    }

    const start = moment(start_date);
    const stop = moment(stop_date);

    if (start.isSame(date, 'day')) {
      return true;
    }

    const isOnInterval =
      start.diff(date, 'days') <= 0 &&
      (!stop_date || stop.diff(date, 'days') >= 0);

    if (!isOnInterval) {
      return false;
    }

    switch (period) {
      case 'day':
        return date.diff(start.add(-1, 'day'), 'days') % multiplicator === 0;
      case 'week':
        return (
          date.diff(start.add(-1, 'day'), 'days') % (multiplicator * 7) === 0
        );
      case 'mouth':
        return (
          date.diff(start.add(-1, 'months'), 'month') % multiplicator === 0 &&
          date.date() === start.date()
        );
      case 'year':
        return (
          date.diff(start, 'year') % multiplicator === 0 &&
          date.date() === start.date() &&
          date.month() === start.month()
        );
      default:
        return false;
    }
  };

  return events
    ? events.find(({ skill_dates }) => checkIsDateInDate(skill_dates[0]))
    : checkIsDateInDate(event);
};



// WEBPACK FOOTER //
// ./src/components/Calendar/utils.js